import React from 'react';
import { Text } from 'wix-ui-tpa/cssVars';
import { BookingDetailsDataHooks } from '../../constants';
import { classes } from '../CalendarSummary.st.css';

export interface PriceWithDiscountProps {
  originalPrice: string;
  priceAfterDiscount: string;
}

export const PriceWithDiscount: React.FC<PriceWithDiscountProps> = ({
  originalPrice,
  priceAfterDiscount,
}) => (
  <div className={classes.priceRow}>
    <Text
      data-hook={BookingDetailsDataHooks.PRICE_BEFORE_DISCOUNT}
      className={classes.priceBeforeDiscount}
    >
      {originalPrice}
    </Text>
    <Text
      data-hook={BookingDetailsDataHooks.SLOT_PLAN_TYPE}
      className={classes.commonTextStyle}
    >
      {priceAfterDiscount}
    </Text>
  </div>
);
